import { DEFAULTAVATAR } from 'Constants'
import React from 'react'
import { FaArrowRightLong } from 'react-icons/fa6'

function RenderProfAccDetailsGrid({data, updatedUserInfo, setIsChange, changeOrg}) {

  const changedRows = Object.entries(data).filter(([label, value]) =>
    updatedUserInfo?.[value] &&
    updatedUserInfo?.[value]?.newValue &&
    (changeOrg === true || (changeOrg === false && value !== "casePref" && value !== "statePref"))
  );

  // Preserve the original per-matching-field setIsChange(true) call count/timing.
  changedRows.forEach(() => setIsChange && setIsChange(true));

  if (!changedRows.length) return null;

  const renderScalar = (val, isEmptyFallback) => {
    if (Array.isArray(val)) {
      if (val.length === 0) {
        return <span className='italic text-gray-400'>--</span>;
      }
      return <span>{val.join(", ")}</span>;
    }
    if (!val) {
      return <span className='italic text-gray-400'>{isEmptyFallback}</span>;
    }
    return <span>{val}</span>;
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-4 w-full lg:px-10">
      {changedRows.map(([label, value]) => {
        const oldValue = updatedUserInfo?.[value]?.oldValue;
        const newValue = updatedUserInfo?.[value]?.newValue;
        return (
          <div key={label} className="flex flex-col col-span-2 items-start mb-3 rounded-lg border border-gray-200 bg-white p-3">
            <label className="font-bold text-navy min-w-[150px] w-max text-xs uppercase tracking-wide mb-2">
              {label}
            </label>
            {label?.includes('pic') ?
              <div className='flex items-center bg-white p-2 gap-2'>
                <div className='w-[150px] flex flex-col border border-gray-200 rounded-lg overflow-hidden'>
                  <div className='w-full bg-gray-100 flex items-center justify-center text-xs font-semibold text-gray-500 py-1'>From</div>
                  <div className='p-2'>
                    <img className="w-full h-auto rounded object-cover" src={oldValue ? oldValue : DEFAULTAVATAR} alt="profilepic" />
                  </div>
                </div>
                <div className='text-tan'><FaArrowRightLong /></div>
                <div className='w-[150px] flex flex-col border border-tan rounded-lg overflow-hidden'>
                  <div className='w-full bg-cream flex items-center justify-center text-xs font-semibold text-tan py-1'>To</div>
                  <div className='p-2'>
                    <img className="w-full h-auto rounded object-cover" src={newValue ? newValue : DEFAULTAVATAR} alt="profilepic" />
                  </div>
                </div>
              </div>
              :
              <div className='flex items-center flex-wrap gap-2 text-sm'>
                <span className='text-gray-400 line-through decoration-gray-300'>
                  {renderScalar(oldValue, "Not yet set")}
                </span>
                <FaArrowRightLong className='text-tan flex-shrink-0' />
                <span className='font-semibold text-navy'>
                  {renderScalar(newValue, "Not yet set")}
                </span>
              </div>
            }
          </div>
        );
      })}
    </div>
  )
}

export default RenderProfAccDetailsGrid
